import { useState } from 'react'
import type { AppProps } from 'next/app'
import { Poppins } from 'next/font/google'
import { ChakraProvider } from '@chakra-ui/react'
import { createStandaloneToast } from '@chakra-ui/toast'

import createCustomTheme, { ThemeColors } from 'styles/createCustomTheme.factory'
import impactoColors from 'styles/colors'
// import { PUBLIC_MODULES_PATHS } from 'constants/publicPages'
import PersonalizationProvider from 'contexts/Personalization/Provider'
import AuthenticationProvider from 'contexts/Authentication/Provider'
// import UserPermissionsManagerProvider from 'contexts/UserPermissionsManager/Provider'
import SidebarProvider from 'contexts/Sidebar/Provider'
// import SocketConnectionManagerProvider from 'contexts/SocketConnection/Provider'
// import NotificationsManagerProvider from 'contexts/NotificationsManager/Provider'
import 'swiper/css'
import 'swiper/css/navigation'

import 'config/styles'
import 'config/yup'
import SummaryManagerProvider from 'contexts/SummaryManager/Provider'
// import FooterImpacto from 'components/media/ImpactoBrand/FooterImpacto'

const poppins = Poppins({
  weight: '400',
  subsets: ['latin'],
})

export default function App({ Component, pageProps }: AppProps) {
  const [mainColor, setMainColor] = useState('gray')

  const { ToastContainer } = createStandaloneToast()

  const themeColors: ThemeColors = impactoColors

  const customTheme = createCustomTheme({
    colors: {
      primary: themeColors[mainColor],
    },
  })

  return (
    <ChakraProvider theme={customTheme}>
      <SummaryManagerProvider>
        <PersonalizationProvider setDefaultColor={setMainColor}>
          {/* <SocketConnectionManagerProvider> */}
            <AuthenticationProvider>
              {/* <UserPermissionsManagerProvider publicModules={PUBLIC_MODULES_PATHS}> */}
                <SidebarProvider>
                  {/* <NotificationsManagerProvider> */}
                  <main className={poppins.className}>
                    <Component {...pageProps} />
                    {/* <FooterImpacto /> */}
                  </main>
                  {/* </NotificationsManagerProvider> */}
                </SidebarProvider>
              {/* </UserPermissionsManagerProvider> */}
            </AuthenticationProvider>
          {/* </SocketConnectionManagerProvider> */}
        </PersonalizationProvider>
      </SummaryManagerProvider>
      <ToastContainer />
    </ChakraProvider>
  )

  // return (
  //   <ChakraProvider theme={customTheme}>
  //     <PersonalizationProvider setDefaultColor={setMainColor}>
  //       <main className={poppins.className}>
  //         <Component {...pageProps} />
  //       </main>
  //     </PersonalizationProvider>
  //   </ChakraProvider>
  // )
}
